export const verifyEmailUpgradeAd = true
export const hamburgerMenu = false
// Wellhub redesign: minimal signup section, design update and "what you get"
// refactor. When disabled the old (pre-#2623) Gympass experience is rendered.
// Off in production; testers can turn it on/off at runtime (see below).
const wellhubDefault = false

// Runtime override so QA can preview the redesign without a rebuild:
//   - `?wellhub=true` / `?wellhub=false` in the URL (also persisted), or
//   - a `wellhub` localStorage key set to 'true' / 'false'.
// Falls back to `wellhubDefault`. SSR-safe: no window access on the server.
export function isWellhubEnabled() {
  if (typeof window === 'undefined') return wellhubDefault

  try {
    const fromQuery = new URLSearchParams(window.location.search).get('wellhub')
    if (fromQuery === 'true' || fromQuery === 'false') {
      window.localStorage.setItem('wellhub', fromQuery)
      return fromQuery === 'true'
    }

    const fromStorage = window.localStorage.getItem('wellhub')
    if (fromStorage === 'true' || fromStorage === 'false') {
      return fromStorage === 'true'
    }
  } catch {
    // localStorage can throw (privacy mode / cookies disabled) — ignore
  }

  return wellhubDefault
}
